// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"581":"eaad6f05","721":"0ba31928"}[chunkId] + ".chunk.css";
};